import { render, staticRenderFns } from "./TextWrappingAndOverFlow.vue?vue&type=template&id=c8ad9b56&"
var script = {}
import style0 from "./TextWrappingAndOverFlow.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports